import { ErrorStateMatcher } from '@angular/material/core';

export const dirtyOrTouchedErrorStateMatcher: ErrorStateMatcher = {
  isErrorState: (control, form) =>
    Boolean(control?.invalid && (control.dirty || control.touched || form?.submitted)),
};
